import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Outlet } from 'react-router-dom';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://gtbuyspreadsheet.work';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'GTBuySpreadsheet',
            url: siteUrl + '/',
            description: 'GTBuy Spreadsheet system — the ultimate automation tool for buying agents, e-commerce sellers, and dropshippers. Compare GTBuy, Kakobuy, and Superbuy spreadsheet solutions.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <Navbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}